import { axiosClient } from '../axiosClient';

type Options = {
  params: { deployId: number };
};

export const deleteDeployment = ({ params }: Options) => {
  return axiosClient.delete(`/deployments/${params.deployId}`);
};
